<template>
  <page>
    <page-title v-t="'p.settingsPage.title'"/>
    <nav-bar>
      <nav-bar-link
        :to="{ name: 'ProfileSettings' }"
        :label="$t('p.settingsPage.navigation.profile')"
        icon="cog"
      />

      <nav-bar-link
        :to="{ name: 'PasswordSettings' }"
        :label="$t('p.settingsPage.navigation.password')"
        icon="key"
      />

      <nav-bar-link
        :to="{ name: 'EmailSettings' }"
        :label="$t('p.settingsPage.navigation.email')"
        icon="at"
      />

      <nav-bar-link
        :to="{ name: 'DestroyProfileSettings' }"
        :label="$t('p.settingsPage.navigation.close_profile')"
        icon="times"
      />
    </nav-bar>
    <router-view />
  </page>
</template>

<script>
import NavBarMixin from '@/mixins/ui/NavBar'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'SettingsPage',
  mixins: [NavBarMixin, PageMixin],
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler ($route) {
        if ($route.path === '/settings') {
          this.$router.push({ name: 'ProfileSettings' })
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/SettingsPage.vue